<template>
  <b-card
    class="card-tiny-line-stats"
  >
    <b-card-header class="d-flex justify-content-between">
      <b-card-title>{{ $t('Pending Actions') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="refreshPendingActions"
      />
    </b-card-header>
    <b-row>
      <b-col
        xl="4"
        sm="6"
      >
        <b-card
          no-body
          class="card card-body-color"
        >
          <b-card-body>
            <b-row>
              <b-col
                xl="12"
                md="12"
                sm="12"
                class="d-flex justify-content-between align-items-center pl-1 pr-1"
              >
                <div class="time-period">
                  14 hours ago
                </div>
                <div>
                  <b-button
                    variant="danger"
                    size="sm"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="12"
                    />
                    Exective
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                xl="12"
                md="12"
                sm="12"
                class="d-flex justify-content-between align-items-center p-2 text-font-size"
              >
                8 Onboarding request(s) are pending your review. <br>Please execute promptly.
              </b-col>
            </b-row>

          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        xl="4"
        sm="6"
      >
        <b-card
          no-body
          class="card card-body-color"
        >
          <b-card-body>
            <b-row>
              <b-col
                xl="12"
                md="12"
                sm="12"
                class="d-flex justify-content-between align-items-center pl-1 pr-1"
              >
                <div class="time-period">
                  29 days ago
                </div>
                <div>
                  <b-button
                    variant="danger"
                    size="sm"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="12"
                    />
                    Exective
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                xl="12"
                md="12"
                sm="12"
                class="d-flex justify-content-between align-items-center p-2 text-font-size"
              >
                10 Loan request(s) are pending your review. <br>Please execute promptly.
              </b-col>
            </b-row>

          </b-card-body>
        </b-card>
      </b-col><b-col
        xl="4"
        sm="6"
      >
        <b-card
          no-body
          class="card card-body-color"
        >
          <b-card-body>
            <b-row>
              <b-col
                xl="12"
                md="12"
                sm="12"
                class="d-flex justify-content-between align-items-center pl-1 pr-1"
              >
                <div class="time-period">
                  2 months ago
                </div>
                <div>
                  <b-button
                    variant="danger"
                    size="sm"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="12"
                    />
                    Exective
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                xl="12"
                md="12"
                sm="12"
                class="d-flex justify-content-between align-items-center p-2 text-font-size"
              >
                12 Collateral request(s) are pending your review. <br>Please execute promptly.
              </b-col>
            </b-row>

          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BButton,
  BCardTitle,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BCardTitle,
  },
  data() {
    return {
      quickLinks: [
        { label: 'Submit Due Diligence', url: '#' },
        { label: 'Apply for a new Loan', url: '#' },
        { label: 'Submit for repayment', url: '#' },
        { label: 'Update end beneficiary data', url: '#' },
        { label: 'Review Financial Performance', url: '#' },
      ],
      exportableReportLinks: [
        { label: 'Loan Summary Report', url: '#' },
        { label: 'Repayment Schedule', url: '#' },
        { label: 'Beneficiary Portfolio data', url: '#' },
      ],
    }
  },
  methods: {
    refreshPendingActions() {},
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
.section-title{
  font-weight: 800;
}
.bulletin-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.bulletin-list li {
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
}
.icons {
  margin: 0 1rem;
  font-size: 1.1rem;
}
.social-title {
  font-size: 1.2rem;
  font-weight: bold;
}
.support-label{
  margin: 0 1rem;
  font-size: 1.1rem;
}
.skype-icon {
  width: 20px;
  height: 20px;
  fill: #00aff0; /* Adjust as needed */
}
.card-body-color {
  border: 1px solid #c0d5eb;
  padding: 5px;
}
.time-period {
  font-size: 12px;
  color: gray;
}
.text-font-size {
  font-size: 12px;
}
</style>
